import React from 'react';
// import { connect, useDispatch } from 'react-redux';
// import AddJob from './workhistory/AddJob';
// import AddJobDetail from './workhistory/AddJobDetail';
import Summary from './workhistory/Summary';
// import initialData from '../initial-data';
// import { HEADING_LINK, WORKHISTORY_LINK, EDUCATION_LINK } from '../constants/constants';
// import { Redirect } from 'react-router';
const EditorWorkHistory = props => {

 
        return <Summary {...props}/>
    // }
}

export default EditorWorkHistory;
